import api from '../../api';
import {
  GET_CAR_FAILURE,
  GET_CAR_LIST_FAILURE,
  GET_CAR_LIST_SUCCESS,
  GET_CAR_SUCCESS,
  GET_CAR_VALIDATE_LIST_FAILURE,
  GET_CAR_VALIDATE_LIST_SUCCESS,
  UPDATE_CAR_SUCCESS
} from '../types';

const state = {
  list: [],
  listUpdated: (new Date()),
  toValidateList: [],
  selected: null,
  selectedUpdated: (new Date())
};


const actions = {
  getCarList({ commit }, query) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      api.getCarList(query).then(response => {
        if (!response.ok) {
          api.stopLoader()
          commit(GET_CAR_LIST_FAILURE)
          return reject(response.body.$error)

        }
        commit(GET_CAR_LIST_SUCCESS, {
          carList: response.body.data
        })
        api.stopLoader()
        return resolve(response.body.data)

      }, response => {
        api.stopLoader()
        commit(GET_CAR_LIST_FAILURE)
        return reject(response.body.$error)
      })
    })

  },

  cleanCarList({ commit }) {
    return commit(GET_CAR_LIST_FAILURE)
  },
  getCar({ commit }, ud) {
    return new Promise((resolve, reject) => {

      api.getCar(ud)
        .then(response => {
          console.log(response);
          if (!response.ok) {
            commit(GET_CAR_FAILURE);
            reject();
          }
          commit(GET_CAR_SUCCESS, {
            car: response.body
          });
          resolve(response.body);
        }, response => {
          commit(GET_CAR_FAILURE);
          reject();
        })
    })
  },


  updateCar({ commit }, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      let avaliables = [
        "id",
        "description",
        "coin",
        "addValueCentavos",
        "markValueCentavos",
        "valueCentavos",
        "typeCar",
        "isTotalLoss",
        "TypeFuelId",
        "ColorId",
        "CategoryId",
        "manufacturer",
        "modell",
        "version",
        "year",
        "yearmanufacture",
        "plate",
        "UserId",
        "UserGroupId",
        "desiredValueCentavos",
        "kbbID",
        "mileage",
        "kbblocateID",
        "UF",
        "locationState",
        "kbbconservationID",
        "conservationState",
        "kbbVendaValueCentavos",
        "kbbVendaMinValueCentavos",
        "kbbVendaMaxValueCentavos",
        "kbbTrocaValueCentavos",
        "kbbTrocaMinValueCentavos",
        "kbbTrocaMaxValueCentavos",
        "kbbManufacturerID",
        "kbbModelID",
        "kbbVersionID",

      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

      api.updateCar(obj)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })

    })
  },


  createCar({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.createCar(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },



  deleteCar({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteCar(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  deleteCarImage({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteCarImage(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },


  //CAR MEASURE

  updateCarMeasure({ commit }, data) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      let avaliables = [
        "id",
        "Measures",
        "HeightRightSide",
        "HeightLeftSide",
        "GreaterWidth",
        "SmallestWidth",
        "Cracks",
        "isShafts",
        "isCeiling",
        "OtherDefects",
        "CategoryId",
        "MeasureId",
        "CarId"
      ];

      let obj = {};

      for (let i of avaliables) {
        if (data.hasOwnProperty(i)) {
          obj[i] = data[i];
        }
      }

      api.updateCarMeasure(obj)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })

    })
  },


  createCarMeasure({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.createCarMeasure(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },



  deleteCarMeasure({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.deleteCarMeasure(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          } else {
            api.stopLoader()
            return resolve(response.body.$success);
          }
        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  getSaleCarList({ commit }, query) {
    return new Promise((resolve, reject) => {

      api.startLoader()
      api.getSaleCarList(query).then(response => {
        if (!response.ok) {
          api.stopLoader()
          commit(GET_CAR_LIST_FAILURE)
          return reject(response.body.$error)

        }
        commit(GET_CAR_LIST_SUCCESS, {
          carList: response.body.data
        })
        api.stopLoader()
        return resolve(response.body.data)

      }, response => {
        api.stopLoader()
        commit(GET_CAR_LIST_FAILURE)
        return reject(response.body.$error)
      })
    })

  },

  getCarToValidateList({ commit }, query) {
    return new Promise((resolve, reject) => {
      api.startLoader()
      api.getCarToValidateList(query).then(response => {
        if (!response.ok) {
          commit(GET_CAR_VALIDATE_LIST_FAILURE)
          api.stopLoader()
          return reject()
        }
        commit(GET_CAR_VALIDATE_LIST_SUCCESS, {
          carPendingList: response.body.data
        })
        api.stopLoader()
        return resolve()
      }, response => {
        commit(GET_CAR_VALIDATE_LIST_FAILURE)
        api.stopLoader()
        return reject()
      })
    })
  },

  approveCar({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()

      api.approveCar(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body.$error);
          }
          api.stopLoader()
          resolve(response.body.$success);

        }, response => {
          api.stopLoader()
          return reject(response.body.$error);
        })
    })
  },

  reproveCar({ commit }, data) {
    return new Promise((resolve, reject) => {
      api.startLoader()

      api.reproveCar(data)
        .then(response => {
          if (!response.ok) {
            api.stopLoader()
            return reject(response.body);
          }
          api.stopLoader()
          return resolve(response.body);

        }, response => {
          api.stopLoader()
          return reject(response.body);
        })
    })
  },

};

const mutations = {

  [UPDATE_CAR_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.car));
  },
  [GET_CAR_LIST_FAILURE](state) {
    state.list = []
  },
  [GET_CAR_LIST_SUCCESS](state, action) {
    state.list = action.carList;
    state.listUpdated = new Date();
  },
  [GET_CAR_FAILURE](state) {
    state.selected = null
  },
  [GET_CAR_VALIDATE_LIST_FAILURE](state) {
    state.toValidateList = []
  },
  [GET_CAR_VALIDATE_LIST_SUCCESS](state, action) {
    state.toValidateList = action.carPendingList;
    state.toValidateListUpdated = new Date();
  },
  [GET_CAR_SUCCESS](state, action) {
    state.selected = JSON.parse(JSON.stringify(action.car));
  },
};

export default {
  state,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/modules/car.js